<template>
  <div class="d-flex align-center" data-tourid="rev-menu-validations">
    <v-tooltip top v-for="action in actions" :key="action.id">
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          :style="action.disabled ? 'cursor: not-allowed;' : ''"
          class="relative"
        >
          <div
            v-if="action.badge && action.badge.show"
            class="rever-badge-wrapper d-flex"
            :style="{
              backgroundColor: action.badge.color,
            }"
            :class="{
              border: !action.badge.content,
            }"
          >
            <div
              class="d-flex aling-center justify-center px-1 font-size-8"
              v-if="action.badge.content"
              :class="[action.badge.textColor]"
            >
              {{ action.badge.content }}
            </div>
          </div>
          <v-btn
            icon
            :disabled="action.disabled || isSaving"
            :data-tourid="action.tourid"
            @click="handleClick(action)"
          >
            <v-icon
              size="20"
              :style="`color: ${action.color} !important;`"
              :data-testid="action.tid"
            >
              {{ action.icon }}</v-icon
            >
          </v-btn>
        </div>
      </template>
      <p class="caption">{{ action.text }}</p>
    </v-tooltip>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'RevActionIcons',

  props: {
    revType: String,
    isLiked: Boolean,
    canHighlight: Boolean,
    isHighlighted: Boolean,
    likesCount: Number,
    isSaving: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    actions() {
      return _.compact([
        {
          id: this.likeId,
          icon: this.likeIcon,
          color: 'white',
          tid: `${this.revType}-button-like`,
          text: this.likeText,
          badge: {
            show: Boolean(this.likesCount) ?? false,
            color: this.$styleVariables?.colorBlue,
            content: this.likesCount,
            position: 'top',
            textColor: 'white--text',
          },
          tourid: 'rev-button-like-icon',
        },
        {
          id: 'highlightRev',
          disabled: !this.canHighlight,
          icon: this.highlightIcon,
          color: this.highlightColor,
          tid: `${this.revType}-button-highlight`,
          text: this.highlightText,
          tourid: 'rev-menu-highlight-icon',
        },
      ])
    },

    likeIcon() {
      return this.isLiked ? 'mdi-heart' : 'mdi-heart-outline'
    },

    likeText() {
      if (this.isLiked) return this.$t('rev.liked')
      return this.$t('rev.header.like_rev')
    },

    likeId() {
      return this.isLiked ? 'unlike' : 'like'
    },

    highlightIcon() {
      return this.isHighlighted ? 'mdi-star' : 'mdi-star-outline'
    },

    highlightText() {
      if (!this.isHighlighted) return this.$t('common.highlight')
      return this.$t('rev.status.highlighted')
    },

    highlightColor() {
      return this.canHighlight
        ? 'white'
        : this.$styleVariables.colorBlueGreyDarken1
    },
  },

  methods: {
    handleClick(action) {
      if (action.disabled) return
      return this.$emit('optionClicked', action.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.rever-badge-wrapper {
  position: absolute;
  z-index: 2;
  border-radius: 10px;
  min-width: 12px !important;
  height: 12px !important;
  top: 4px;
  left: 20px;
}

.border {
  border: 2.5px solid $color-blue-grey-darken3 !important;
}
</style>
